import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import Navbar from "../components/Navbar";
import { Bell, Calendar, Clock } from "lucide-react";
import { useLocation } from "react-router-dom";

const ViewReminders = () => {
  const { setAlert, setMessage, setSessionTimeout } = useContext(languageContext);
  const [reminders, setReminders] = useState([]);
  const location = useLocation();

  const fetchReminders = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/all_reminder",
        JSON.stringify({ id: patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setReminders(response.data.data || []);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Failed to fetch reminders. Try again later.");
        console.error(error);
      }
    }
  };

  const getReminderTypeLabel = (type) => {
    if (type?.toLowerCase() === "am") return "Morning";
    if (type?.toLowerCase() === "pm") return "Evening";
    if (type?.toLowerCase() === "nt") return "Night";
    return type;
  };

  useEffect(() => {
    fetchReminders();
  }, []);

  return (
    <div className="flex flex-col h-screen bg-gradient-to-br from-blue-50 to-white">
      <Navbar />

      <div className="flex flex-col pt-24 px-4 pb-4 overflow-hidden h-full max-w-6xl mx-auto w-full">
        <h2 className="text-3xl font-bold text-blue-800 text-center mb-4">
          🔔 Patient Reminders
        </h2>

        <div className="flex-grow overflow-y-auto rounded-lg scrollbar-thin scrollbar-thumb-blue-300 scrollbar-track-transparent">
          {reminders.length === 0 ? (
            <div className="text-center text-gray-600 text-lg italic py-10">
              No reminders available.
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pb-4">
              {reminders.map((reminder) => (
                <div
                  key={reminder.id}
                  className="bg-white rounded-xl p-4 shadow hover:shadow-lg transition duration-200 border border-blue-100"
                >
                  <div className="flex items-center gap-2 mb-2">
                    <Bell className="text-blue-600 w-5 h-5" />
                    <span className="text-blue-900 font-medium text-sm">
                      {reminder.medicine_name}
                    </span>
                  </div>

                  <div className="flex items-center text-gray-600 text-sm mb-1">
                    <Calendar className="w-4 h-4 mr-1" />
                    {reminder.start_date} – {reminder.end_date}
                  </div>

                  <div className="flex items-center text-gray-600 text-sm mb-1">
                    <Clock className="w-4 h-4 mr-1" />
                    {reminder.time} ({getReminderTypeLabel(reminder.reminder_type)})
                  </div>

                  <div className="text-gray-700 text-sm mt-2">
                    <strong>Days:</strong> {reminder.reminder_day.join(", ")}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewReminders;
